var slick = require("slick-carousel");
var PubSub = require("underpub-js");
var loadTouchEvents = require('jquery-touch-events');
loadTouchEvents($);

var Gallery6 = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

Gallery6.prototype.init = function(){

  var self = this;
  
  this.options.$el.find('.image-slider').slick({
    dots: true,
    slidesToShow: 1,
    infinite: true,
    dots: false,
    centerMode: true,
    centerPadding: '0%',
    swipe: false,
    variableWidth: true,
    
    responsive: [
      {
        breakpoint: 800,
        settings: {
          centerMode: false,
          variableWidth: false
        }
      }
    ]
    
  });

  // on window resize
  PubSub.subscribe("resized", function(){
    self.options.$el.find('.image-slider').slick('slickGoTo', self.options.$el.find('.image-slider').slick('slickCurrentSlide') );
  });

  // swipe events
  this.options.$el.on('swiperight', function() {
    self.prevSlide();
  });

  this.options.$el.on('swipeleft', function() {
    self.nextSlide();    
  });

  this.options.$el.find('.slider-arrows-nav .next-arrow').on('click', function() {
    self.nextSlide();    
  });

  this.options.$el.find('.slider-arrows-nav .prev-arrow').on('click', function() {
    self.prevSlide();
  });

};

Gallery6.prototype.nextSlide = function(){

  var self = this;

  var currentSlideIndex = self.options.$el.find('.slick-slide.slick-active').data('slickIndex');
  var totalNumberOfSlides = self.options.$el.data('slideCount');

  self.options.$el.find('.slider-arrows-nav .disabled').removeClass('disabled');

  if (currentSlideIndex < (totalNumberOfSlides - 1))
  {
    self.options.$el.find('.image-slider').slick('slickNext');
  }

  if (currentSlideIndex >= (totalNumberOfSlides - 2))
  {
    self.options.$el.find('.slider-arrows-nav .next-arrow').addClass('disabled');
  }

};

Gallery6.prototype.prevSlide = function(){

  var self = this;

  var currentSlideIndex = self.options.$el.find('.slick-slide.slick-active').data('slickIndex');

  self.options.$el.find('.slider-arrows-nav .disabled').removeClass('disabled');

  if (currentSlideIndex > 0) {
    self.options.$el.find('.image-slider').slick('slickPrev');
  }

  if (currentSlideIndex <= 1)
  {
    self.options.$el.find('.slider-arrows-nav .prev-arrow').addClass('disabled');
  }

};

module.exports = Gallery6;
